import { jsx as t } from "react/jsx-runtime";
import i from "clsx";
import { s as e } from "../../../form-item.module-avu57bh1.js";
const n = ({
  id: r,
  children: o,
  className: m,
  ...s
}) => /* @__PURE__ */ t(
  "div",
  {
    id: r,
    className: i(e["form-item__description"], m),
    ...s,
    children: o
  }
);
export {
  n as FormItemDescription
};
